import React from 'react';
import PropTypes from 'prop-types';

import { TranslatedLinkMessage } from './TranslatedLinkMessage';

const AgeRequirementText = ({ age }) => {
  return (
    <p>
      <TranslatedLinkMessage
        id={'AGE_REQUIREMENT_TEXT'}
        link={'AGE_REQUIREMENT_URL'}
        linkText={'AGE_REQUIREMENT_LINK_TEXT'}
        inlineData={{ age }}
      />
    </p>
  );
};

AgeRequirementText.propTypes = {
  age: PropTypes.number.isRequired,
};

export default AgeRequirementText;
